import { render, staticRenderFns } from "./notUpgradedList.vue?vue&type=template&id=5d15588a&"
import script from "./notUpgradedList.vue?vue&type=script&lang=js&"
export * from "./notUpgradedList.vue?vue&type=script&lang=js&"
import style0 from "./notUpgradedList.vue?vue&type=style&index=0&id=5d15588a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports